import { Controller } from 'stimulus';
import Rails from 'rails-ujs';

export default class extends Controller {
  static targets = ['isListedOnFlie'];

  handleIsListedOnFlieChange() {
    if (this.isListedOnFlieTarget.checked) {
      if (confirm('FLIEの掲載状態を有効にしますか？')) {
        this.updateIsListedOnFlie();
      } else {
        this.isListedOnFlieTarget.checked = false;
      }
    } else {
      if (confirm('FLIEの掲載状態を無効にしますか？')) {
        this.updateIsListedOnFlie();
      } else {
        this.isListedOnFlieTarget.checked = true;
      }
    }
  }

  updateIsListedOnFlie() {
    const estateId = this.isListedOnFlieTarget.defaultValue;
    const isListedOnFlie = this.isListedOnFlieTarget.checked;

    let formData = new FormData();
    formData.append('is_listed_on_flie', isListedOnFlie);

    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/estates/${estateId}/update_is_listed_on_flie`,
      data: formData,
      contentType: 'application/json',
      success: (json) => {
        alert(`FLIEの掲載状態を${json.is_listed_on_flie ? '有効' : '無効'}にしました`);
      },
      error: (response) => {
        // バリデーションエラーの場合はメッセージを表示してチェックを戻す
        let message = 'エラーが発生しました。ブラウザをリロードして、再度お試しください。';
        let isValidationError = false;
        if (response && response.errors) {
          message = 'FLIE掲載に必要な項目が不足しています。\n編集画面でFLIE掲載チェックをONにして必須項目を入力してください。\n\n' + response.errors.join('\n') + '\n\nOK: 編集画面を開く\nキャンセル: 一覧に戻る';
          isValidationError = true;
        } else if (response && response.error) {
          message = response.error;
        }
        this.isListedOnFlieTarget.checked = !isListedOnFlie;
        if (isValidationError) {
          if (confirm(message)) {
            window.location.href = `/realtor/estates/${estateId}/edit`;
          }
        } else {
          alert(message);
        }
      }
    });
  }
}
